import React, { PropsWithChildren, useContext } from 'react'
import { SecondaryPageBanner } from '../../../fragments/secondaryPageBanner'
import { GlobalContext } from '../../../globals/context'
import { isNotNull } from '../../../utils/nonNull'
import { SecondaryPageBannerFragment } from '@gql'

type BannerProps = {
  data: SecondaryPageBannerFragment[]
  breadcrumbs: React.ReactNode
}

export const ProductDetailsBanner: React.FC<PropsWithChildren<BannerProps>> = ({ data, breadcrumbs }) => {
  const { fallback } = useContext(GlobalContext)
  
  if (!data[0] || data[0].__typename !== 'secondaryPageBanner_BlockType' || fallback?.globalSet?.__typename !== 'siteSettings_GlobalSet') {
    return null
  }

  const { productDetailImageFallback } = fallback.globalSet

  const { title, subTitle, primaryButton, secondaryButton, image, subBanner } = data[0]

  const bannerImage = isNotNull(image) && image.length> 0 ? image: productDetailImageFallback as typeof image

  return (
    <SecondaryPageBanner
      after={'light'}
      title={title}
      subTitle={subTitle}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      image={bannerImage}
      breadcrumbs={breadcrumbs}
      subBanner={subBanner}
    />
  )
}
